export const swedBankDefaults = {
  deviceIp: '',
  devicePort: '',
  printMerchantReceipt: 'never',
  printCustomerReceipt: 'never',
};

export const swedbankFields = {
  deviceIp: {
    id: 'deviceIp',
    title: 'Device IP',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val?.match(/[^\da-zA-Z.-]/g)?.length
          ? 'Invalid device IP.'
          : null;
      }
      return 'Device IP is required.';
    },
  },
  devicePort: {
    id: 'devicePort',
    title: 'Device Port',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val?.match(/[^\d]/g)?.length ? 'Invalid Device Port' : null;
      }
      return 'Device Port is required.';
    },
  },
  printReceipt: {
    id: 'printReceipt',
    title: 'Print receipt for',
    type: 'select',
    options: [
      { name: 'Merchant and Customer', value: '1' },
      { name: 'Merchant', value: '0' },
      { name: 'None', value: '2' },
    ],
  },
  printingDevice: {
    id: 'printingDevice',
    title:
      'Print from terminal. If No printing from terminal is selected, Erply POS printer will be used as default.',
    type: 'select',
    options: [
      { name: 'Internal terminal printer', value: '1' },
      { name: 'External POS printer', value: '0' },
    ],
  },
};
